import React, { useEffect, useState } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import ReLoginModal from "../ReLoginModal";

const EditProduct = ({ saveData, handleEdit }: any) => {
  const [edit, setEdit] = useState({
    name: saveData?.name,
    description: saveData?.description,
    cost: saveData?.price.cost,
    category: saveData?.category,
    selling: saveData?.price.selling,
    unitOfMeasure: saveData?.unitOfMeasure,
    quantity: saveData?.quantity,
  });
  const [role, setRole] = useState("");

  useEffect(() => {
    const getUserData = window.localStorage.getItem("userData");

    if (getUserData) {
      const getUser = JSON.parse(getUserData);
      setRole(getUser.account.role);
      console.log(role);
    } else {
      console.log("User data not found in localStorage");
    }
  }, []);

  const token = window.localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const [reLogin, setReLogin] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = ({ target: { name, value } }: any) => {
    setEdit((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };
  const datas = {
    name: edit.name,
    description: edit.description,
    category: edit.category,
    unitOfMeasure: edit.unitOfMeasure,
    quantity: edit.quantity,
    price: {
      cost: edit.cost,
      selling: edit.selling,
    },
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();
    axios
      .patch(
        `https://apibiz.oneflaretech.com/api/inventory/${saveData?._id}`,
        datas,
        {
          headers: headers,
        }
      )
      .then((res) => {
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  return (
    <div className="modal">
      {reLogin ? <ReLoginModal /> : null}
      <form onSubmit={handleSubmit} className="catModal">
        <div className="catModalTop">
          <h4>Edit</h4>
          <ImCancelCircle className="catCancel" onClick={handleEdit} />
        </div>
        <div className="line"></div>

        <div className="catModalInput branchInput qunnt">
          <div className="div modalDouble">
            <div className="proQu ed">
              <label htmlFor="">Product Name</label>
              <input
                type="text"
                placeholder="Product name"
                name="name"
                value={edit.name}
                onChange={handleChange}
              />
            </div>
            <div className="proQu ed">
              <label htmlFor="">Product Description</label>
              <input
                type="text"
                placeholder="Product description"
                name="description"
                value={edit.description}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="div modalDouble">
            <div className="proQu ed">
              <label htmlFor="">Selling Price</label>
              <input
                type="tel"
                placeholder="Product Selling Price"
                name="selling"
                value={edit?.selling}
                onChange={handleChange}
              />
            </div>
            <div className="proQu ed">
              <label htmlFor="">Product Category</label>
              <input
                disabled={role !== "admin"}
                type="text"
                placeholder="Product Category"
                name="category"
                value={edit.category}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="proQu ed">
            <label htmlFor="">Unit Of Measurement</label>
            <input
              disabled
              type="text"
              placeholder="Unit of measuremnt"
              name="unitOfMeasure"
              value={edit.unitOfMeasure}
              onChange={handleChange}
            />
          </div>
          <div className="proQu ed">
            <label htmlFor="">Quantity</label>
            <input
              type="text"
              placeholder="Quantity"
              name="quantity"
              value={edit.quantity}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="catModalBtn">
          <button type="submit" className="catBtn1">
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "25px", height: "25px" }}
              />
            ) : (
              "Edit"
            )}
          </button>
          <button className="catBtn1 re1" type="submit" onClick={handleEdit}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProduct;
